import React from 'react';
import { motion } from 'framer-motion';

const GOAL_OPTIONS = [
  { key: 'track_patterns', label: 'Track my symptoms and patterns', icon: '~' },
  { key: 'doctor_prep', label: 'Prepare for doctor appointments', icon: '~' },
  { key: 'understand_conditions', label: 'Understand my conditions better', icon: '~' },
  { key: 'healthy_habits', label: 'Build healthier habits', icon: '~' },
  { key: 'manage_medications', label: 'Manage my medications', icon: '~' },
  { key: 'talk_health', label: 'Have someone to talk to about my health', icon: '~' },
  { key: 'mental_health', label: 'Monitor my mental health', icon: '~' },
  { key: 'health_record', label: 'Keep a health record', icon: '~' },
];

export const OnboardingGoals = ({ data, onChange }) => {
  const goals = data.goals || { selected: [], custom: '' };

  const toggleGoal = (key) => {
    const selected = goals.selected || [];
    const updated = selected.includes(key)
      ? selected.filter(g => g !== key)
      : [...selected, key];
    onChange({ ...data, goals: { ...goals, selected: updated } });
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-6">
      {/* Kindra message */}
      <div className="bg-white border border-slate-150 rounded-2xl p-5">
        <p className="text-slate-700 leading-relaxed">
          Last thing — what would you like Kindra to help you with?
        </p>
        <p className="text-sm text-slate-400 mt-2">
          Pick what matters most. You can change these anytime.
        </p>
      </div>

      {/* Goal cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        {GOAL_OPTIONS.map(({ key, label }) => {
          const selected = (goals.selected || []).includes(key);
          return (
            <button
              key={key}
              data-testid={`onboarding-goal-${key}`}
              onClick={() => toggleGoal(key)}
              className={`text-left px-4 py-3.5 rounded-xl border transition-all text-sm ${
                selected
                  ? 'bg-[#235347]/5 border-[#235347] text-[#235347] font-medium'
                  : 'bg-white border-slate-200 text-slate-600 hover:border-slate-300'
              }`}
            >
              {label}
            </button>
          );
        })}
      </div>

      {/* Custom goal */}
      <div>
        <label className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-2 block">Anything specific?</label>
        <input
          data-testid="onboarding-goal-custom"
          placeholder="e.g. Figure out if my fatigue is medication-related"
          value={goals.custom || ''}
          onChange={(e) => onChange({ ...data, goals: { ...goals, custom: e.target.value } })}
          className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#235347]/20"
        />
      </div>

      {(goals.selected || []).length === 0 && (
        <p className="text-xs text-amber-600">Please select at least one goal to continue.</p>
      )}
    </motion.div>
  );
};
